import type { ComponentPropsWithRef, ReactNode } from "react";
import { Fragment, forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesSecondaryBlockDefaultStyles } from "../constants";

export interface SalesBlock92Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content?: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const SalesBlock9_2 = forwardRef<HTMLDivElement, SalesBlock92Props>(
  ({ header, content, footer, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesSecondaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background
          className="wb-bg-secondary"
          style={backgroundStyles}
        >
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-mx-auto wb-flex wb-max-w-3xl wb-flex-col wb-items-center wb-gap-4 wb-text-center md:wb-gap-6">
                {header}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-gap-6 md:wb-grid md:wb-grid-cols-2 wb-mx-auto wb-max-w-3xl md:wb-gap-[1.875rem]">
                {content}
              </BlockSection.NestedBlock>
              <BlockSection.NestedBlock
                as={Fragment}
                block={footer}
                render={() => (
                  <div className="wb-mx-auto wb-flex wb-flex-col wb-justify-center wb-gap-10 md:wb-gap-16">
                    <div className="wb-flex wb-flex-col wb-items-center wb-gap-4 md:wb-gap-8">
                      {footer}
                    </div>
                  </div>
                )}
              />
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock9_2.displayName = "SalesBlock9_2";
